export default __webpack_public_path__ + "static/media/gs.2ec26ca3.svg";